module.exports = __webpack_public_path__ + "static/media/hotdoc-horz.e2e549c6.png";